export const VERIFY_CODE = "VERIFY_CODE"
export const VERIFY_CODE_SUCCESSFUL = "VERIFY_CODE_SUCCESSFUL"
export const VERIFY_CODE_FAILED = "VERIFY_CODE_FAILED"